module.exports = {
    SERVER_BASE_URL: process.env.REACT_APP_SERVER_BASE_URL
}